import { Select, Spin, DatePicker, Input } from 'antd'
import classnames from 'classnames'
import { Component, ReactNode } from 'react'
// import DatePicker from 'react-date-picker';
import ReactDropdown from 'react-dropdown'
import { toast } from 'react-toastify'

import { MiscNoteFieldDto, NewNoteDto, UpdateNoteDto, NoteTopicDto } from '../../../../definition/notes.dto'
import { appEventEmitter, processLoading } from '../../../../initialization'
import { asyncGetListNoteTopic, asyncGetMiscNote, asyncCreateTopic } from '../../../../services/notes.service'

import { isEmpty } from 'lodash'
import moment, { Moment } from 'moment'
import { APP_EVENTS } from '../../../../constants'
import { uploadAvatar } from '../../../../services'
import { asyncGetListTechnicians } from '../../../../services/technician.service'
import { timeSlotToDate } from '../../../../utils/datetime'
import { ModalNode, ModalNodeProps } from '../../../components/modal.component'
import defaultAvatar from './../../../../styles/images/image-icon.png'
import { NoteTopicsModal } from './note-topic-modal'
import { ScheduleCalendarConfigurationType } from '../../../../definition/time-slot.dto'
import { asyncUpdateNote } from '../../../../services/notes.service'
import TextArea from 'antd/lib/input/TextArea'
import { employeeLabel } from '../../../../utils'

export interface NewMiscNoteState {
  miscNoteId?: string
  miscNote?: NewNoteDto | UpdateNoteDto
  miscNoteTopic?: NoteTopicDto

  date: Date
  dateError?: boolean

  timeSlotBegin: string
  timeSlotEnd: string
  timeSlotError?: boolean

  mediaId?: string
  mediaIsTemporary?: boolean
  mediaUrl?: string

  topicId?: string
  topicError?: boolean
  topicOptions: DropdownOptionProps[]

  fields?: MiscNoteFieldDto[]

  subject?: string
  subjectError?: boolean

  notes?: string
  notesError?: boolean

  isNew: boolean
  isEditing: boolean

  editable: boolean

  onSaveCb: (miscNoteDto: NewNoteDto | UpdateNoteDto) => void

  selectionTechnicians: { label: string; value: string }[]
  isLoadingTechnician?: boolean
  selectedTechnicianId?: string
  bookingId: string
}

export interface DropdownOptionProps {
  value: string // Service Id
  label: string
  className?: string
  createdAt?: string | Date
  modifiedAt?: string | Date
}

export class NewMiscNoteModal extends Component<
  ModalNodeProps<{ configuration: ScheduleCalendarConfigurationType } & any>,
  NewMiscNoteState
> {
  constructor(props: any) {
    super(props)
    const data = this.props.input
    const date = new Date()

    this.state = {
      isNew: !data.noteId && !data.miscNote,
      isEditing: !data.noteId,
      miscNoteId: data.noteId, // In case view note
      miscNote: data.miscNote, // In case update note after add new

      date: date,
      timeSlotBegin: '',
      timeSlotEnd: '',
      topicOptions: [],

      fields: [],

      editable: data.editable !== undefined ? data.editable : data.editable,

      onSaveCb: data.onSave,
      selectionTechnicians: [],
      bookingId: data.bookingId
    }
  }

  componentDidMount() {
    this.doInit()
  }

  async doInit() {
    await processLoading(this.processInit())
  }

  async processInit() {
    const noteTopics = (await asyncGetListNoteTopic({ all: true }))?.items || []

    const noteTopicOptions: DropdownOptionProps[] = noteTopics.map((topic) => ({
      value: topic.id,
      label: topic.name,
      createdAt: topic.createdAt,
      modifiedAt: topic.modifiedAt
    }))

    if (noteTopicOptions && noteTopicOptions.length > 0) {
      this.setState({
        topicOptions: noteTopicOptions
      })
    } else {
      const topic = await asyncCreateTopic({
        name: 'Fake topics'
      })
      if (topic) {
        this.setState({
          topicOptions: [
            {
              value: topic.id,
              label: topic.name,
              createdAt: topic.createdAt,
              modifiedAt: topic.modifiedAt
            }
          ],
          topicId: undefined
        })
      }
    }

    if (this.state.miscNoteId) {
      const miscNote = await asyncGetMiscNote(this.state.miscNoteId)
      if (miscNote) {
        this.setState({
          date: moment(miscNote.timeSlotBeginAt).toDate(),
          timeSlotBegin: moment(miscNote.timeSlotBeginAt).format('hh:mmA'),
          timeSlotEnd: moment(miscNote.timeSlotEndAt).format('hh:mmA'),
          mediaUrl: miscNote.mediaUrl,
          mediaId: miscNote.mediaId,
          subject: miscNote.subject,
          notes: miscNote.note,
          topicId: miscNote.miscNoteTopic.id,
          miscNoteTopic: miscNote.miscNoteTopic,
          fields: miscNote.miscNoteFields
        })
      }
    } else if (this.state.miscNote) {
      const miscNote = this.state.miscNote
      this.setState({
        date: moment(miscNote.timeSlotBeginAt).toDate(),
        timeSlotBegin: moment(miscNote.timeSlotBeginAt).format('hh:mmA'),
        timeSlotEnd: moment(miscNote.timeSlotEndAt).format('hh:mmA'),
        mediaIsTemporary: miscNote.mediaIsTemporary,
        mediaId: miscNote.mediaId,
        mediaUrl: miscNote.mediaUrl,
        subject: miscNote.subject,
        notes: miscNote.note,
        topicId: miscNote.miscNoteTopicId,
        fields: miscNote.miscNoteFields
      })
    }
  }

  validate = () => {
    const validateStatus: any = {}
    if (!this.state.subject) {
      validateStatus.subjectError = true
    }
    if (!this.state.notes) {
      validateStatus.notesError = true
    }

    if (!isEmpty(validateStatus)) {
      this.setState({
        ...validateStatus
      })
      return false
    }

    return true
  }

  onNew = async () => {
    if (!this.validate()) {
      return
    }

    const dates = timeSlotToDate(this.state.date, this.state.timeSlotBegin, this.state.timeSlotEnd)

    const dto: NewNoteDto = {
      timeSlotBeginAt: dates.dateStart,
      timeSlotEndAt: dates.dateEnd,
      mediaIsTemporary: this.state.mediaIsTemporary,
      mediaId: this.state.mediaId,
      mediaUrl: this.state.mediaUrl,
      subject: this.state.subject || '',
      note: this.state.notes || '',
      miscNoteTopicId: this.state.topicId || this.state.topicOptions?.[0]?.value,
      // this topicId bcz due to new CR has to remove, but it complex to remove in BE, so still pass param here
      miscNoteFields: this.state.fields || []
    }

    this.state.onSaveCb(dto)

    // incase already has booking without note
    if (this.state.bookingId) {
      this.props.onDone?.(dto)
    }
    this.props.onClose?.()
  }

  onUpdate = async () => {
    if (!this.validate()) {
      return
    }

    const dates = timeSlotToDate(this.state.date, this.state.timeSlotBegin, this.state.timeSlotEnd)

    const dto: UpdateNoteDto = {
      timeSlotBeginAt: dates.dateStart,
      timeSlotEndAt: dates.dateEnd,
      mediaIsTemporary: this.state.mediaIsTemporary,
      mediaId: this.state.mediaId,
      subject: this.state.subject || '',
      note: this.state.notes || '',
      miscNoteTopicId: this.state.topicId || this.state.topicOptions[0].value,
      // this topicId bcz due to new CR has to remove, but it complex to remove in BE, so still pass param here
      miscNoteTopic: this.state.miscNoteTopic,
      miscNoteFields: this.state.fields || []
    }

    if (this.state.miscNoteId) {
      try {
        await asyncUpdateNote(this.state.miscNoteId, dto)
        toast.success(<>The note have been update</>)
      } catch (error: any) {
        const errMsg = error.response?.data?.error?.message || error.message
        console.error(errMsg)
        toast.error(<>{errMsg}</>)
      }
    }

    this.state.onSaveCb(dto)

    this.props.onDone?.()
  }

  onSearchTechnicians(index: number, search: string) {
    const fields = this.state.fields || []
    fields[index].fieldValue = this.state.selectionTechnicians.find((item) => item.value === search)?.label

    if (!search) {
      this.setState({
        fields,
        selectionTechnicians: []
      })
      return
    }
    this.setState({
      fields,
      isLoadingTechnician: true,
      selectionTechnicians: []
    })
    asyncGetListTechnicians({ search, all: true }).then((res) => {
      this.setState({
        fields,
        isLoadingTechnician: false,
        selectionTechnicians: (res?.items || []).map((item) => ({
          label: item.profile?.name as string,
          value: item.id
        }))
      })
    })
  }

  onSelectTechnician = (index: number, selectedTechnicianId?: string) => {
    const fields = this.state.fields || []
    fields[index].fieldValue = this.state.selectionTechnicians.find(
      (item) => item.value === selectedTechnicianId
    )?.label

    this.setState({
      fields,
      selectedTechnicianId
    })
  }

  onMediaUpload = async (selectedFiles: FileList | null) => {
    if (selectedFiles && selectedFiles.length > 0) {
      try {
        const data = await uploadAvatar(selectedFiles[0])
        this.setState({
          mediaId: data.fileId,
          mediaIsTemporary: true,
          mediaUrl: data.loadTempUrl
        })
      } catch (error: any) {
        const errMsg = error.response?.data?.error?.message || error.message
        console.error(errMsg)
        toast.error(<>{errMsg}</>)
      }
    }
  }

  loadNoteTopics = async (searchData?: { selectedPage?: number }) => {
    const offset = (searchData?.selectedPage || 0) * 10
    return await asyncGetListNoteTopic({
      offset: offset,
      limit: 10
    })
  }

  selectedTopicAndFields = async (topicId: string, fields: MiscNoteFieldDto[]) => {
    await this.doInit()
    this.setState({
      topicId: topicId,
      fields: fields
    })
  }

  onNoteTopicManage = () => {
    appEventEmitter.emit<ModalNode>(APP_EVENTS.app_modal, {
      input: {
        loadNoteTopics: this.loadNoteTopics,
        miscNoteId: this.state.miscNoteId,
        fields: this.state.fields,

        selectedTopicAndFields: this.selectedTopicAndFields
      },
      status: true,
      node: NoteTopicsModal,
      title: 'Topics',
      onClose: () => {
        this.doInit()
      },
      onDone: () => {
        this.doInit()
      }
    })
  }

  onChangeDate(selectedDate: Moment | null) {
    if (selectedDate) {
      this.setState({
        date: selectedDate?.toDate(),
        dateError: false
      })
    }
  }

  renderButton() {
    if (this.state.editable) {
      if (this.state.isNew) {
        return (
          <button className='primary' onClick={this.onNew}>
            Add Note
          </button>
        )
      } else {
        return (
          <button
            className='primary'
            onClick={() => {
              if (this.state.isEditing) {
                this.onUpdate()
              } else {
                this.setState({
                  isEditing: true
                })
              }
            }}
          >
            {!this.state.isEditing ? 'Edit Note' : 'Save Note'}
          </button>
        )
      }
    } else {
      return (
        <button
          className='primary'
          onClick={() => {
            this.props.onClose?.()
          }}
        >
          Close
        </button>
      )
    }
  }

  render(): ReactNode {
    return (
      <div className='new-note-modal'>
        <div className='row'>
          <div className={classnames('column', 'fix-content')}>
            <div className='label-input'>
              <label>Media Upload</label>
              <label className='input-avatar'>
                <input type='file' hidden onChange={(e) => this.onMediaUpload(e.target.files)} />
                <img alt='media' src={this.state.mediaUrl || defaultAvatar} />
              </label>
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='column'>
            {this.state.fields?.map((field, index) => {
              return (
                field.check && (
                  <div className='label-input' key={index}>
                    <label>{field.name}</label>

                    {field.name === 'Technician Assigned' ? (
                      <Select
                        showSearch
                        allowClear
                        placeholder={`Filter ${employeeLabel({ isFirstLetterUp: true })}`}
                        searchValue={field.fieldValue}
                        style={{ width: '100%' }}
                        filterOption={false}
                        value={this.state.selectedTechnicianId}
                        onSearch={this.onSearchTechnicians.bind(this, index)}
                        onSelect={this.onSelectTechnician.bind(this, index)}
                        onClear={() => this.onSelectTechnician(index)}
                        notFoundContent={this.state.isLoadingTechnician ? <Spin size='small' /> : null}
                        options={this.state.selectionTechnicians}
                      />
                    ) : (
                      <input
                        value={field.fieldValue}
                        onChange={(e) => {
                          field.fieldValue = e.target.value
                          this.forceUpdate()
                        }}
                        disabled={!this.state.isEditing}
                      />
                    )}
                  </div>
                )
              )
            })}
          </div>
        </div>

        <div className='row'>
          <div className={classnames('column')}>
            <div className='label-input'>
              <label>Subject</label>
              <Input
                className={this.state.subjectError ? 'input-error' : ''}
                value={this.state.subject}
                onChange={(e) => {
                  this.setState({
                    subject: e.target.value,
                    subjectError: isEmpty(e.target.value)
                  })
                }}
                disabled={!this.state.isEditing || !this.state.editable}
              />
            </div>
          </div>
        </div>
        <div className='row'>
          <div className={classnames('column', 'flex-width')}>
            <div className='label-input'>
              <label>Notes</label>
              <TextArea
                style={{ height: '150px' }}
                value={this.state.notes}
                className={this.state.notesError ? 'input-error' : ''}
                onChange={(e) => {
                  this.setState({
                    notes: e.target.value,
                    notesError: isEmpty(e.target.value)
                  })
                }}
                disabled={!this.state.isEditing || !this.state.editable}
              />
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='action-button'>{this.renderButton()}</div>
        </div>
      </div>
    )
  }
}
